import { useFormat } from '@pos/admin-ui';
import { useTranslation } from '@pos/i18n';
import type { ImageAsset } from './imagesApi';

/** How an image is named and sized on screen: its file name (else its description), and "W × H · KB". */
export function useImageText() {
  const { t } = useTranslation();
  const format = useFormat();
  return {
    name: (p: ImageAsset) => p.originalName || p.altText || t('images.untitled'),
    size: (p: ImageAsset) =>
      t('images.size', {
        width: format.number(p.width),
        height: format.number(p.height),
        kb: format.number(Math.max(1, Math.round(Number(p.byteSize) / 1024))),
      }),
    dimensions: (p: ImageAsset) => t('images.dimensions', { width: format.number(p.width), height: format.number(p.height) }),
    fileSize: (p: ImageAsset) => t('images.fileSize', { kb: format.number(Math.max(1, Math.round(Number(p.byteSize) / 1024))) }),
  };
}
